class BxfFormGroupConstants {
    static STRING = {
        CONTAINER: 'bxf-form-group__container',
        CONTAINER_WITH_DIVIDER: 'bxf-form-group__container--divider',
        CONTAINER_WITH_TOP_DIVIDER: 'bxf-form-group__container--top-divider',
        HEADER: 'oneds-blk-body-xs-bold',
        SPACING: 'bxf-form__spacing',
        HEADER_DISABLED: 'bxf-form-group__header-disabled',
        DISABLED: 'disabled',
    };
}

class BxfFormItemConstants {
    static STRING = {
        CONTAINER: 'bxf-form-item__container',
        SUFFIX_SLOT: 'bxf-form-item__suffix-slot',
    };
}

class BxfFormConstants {
    static STRING = {
        CONTAINER: 'bxf-form__container',
        HEADER: 'oneds-blk-heading-xxs',
        SPACING: 'bxf-form__spacing',
        FORM_GROUP_TAGNAME: 'BXF-FORM-GROUP',
    };
}

export { BxfFormGroupConstants as B, BxfFormItemConstants as a, BxfFormConstants as b };
